import video from '@/dto/video'

export default function() {
    return {
        video: Object.assign({}, video),
        success: false,
        error: false,
        errors: {
            youtubeLink: null,
            title: null
        }
    }
}
